import { render, staticRenderFns } from "./CorrerEvento.vue?vue&type=template&id=2c8d3107&"
import script from "./CorrerEvento.vue?vue&type=script&lang=js&"
export * from "./CorrerEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports